import { LocaleContext } from '~/components/LocaleContext'

class Money {
  constructor({ amount, currency }, locale = 'en') {
    this.amount = amount
    this.currency = currency
    this.locale = locale
  }

  add = ({ amount, currency }) => {
    if (currency !== this.currency) {
      throw new Error('Currency mismatch')
    }

    this.amount = this.amount + amount

    return this
  }

  subtract = ({ amount, currency }) => {
    if (currency !== this.currency) {
      throw new Error('Currency mismatch')
    }

    this.amount = this.amount - amount

    return this
  }

  multiply = multiplier => {
    this.amount = this.amount * multiplier

    return this
  }

  percentage = percentage => {
    this.amount = Math.round((this.amount * percentage) / 100)

    return this
  }

  format = () => {
    return global.Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
    }).format(this.amount / 100)
  }
}

export const formatMoney = money => {
  if (!money) return null

  const locale = LocaleContext._currentValue

  return new Money(money, locale).format()
}

export const getCurrencySymbol = currency => {
  if (!currency) return null

  const locale = LocaleContext._currentValue

  return global.Intl.NumberFormat(locale, { style: 'currency', currency })
    .formatToParts()
    .find(({ type }) => type === 'currency').value
}

export const getCurrencies = (currencies, t) =>
  currencies.map(({ code }) => ({
    code,
    name: t(`common:currencies.${code}`),
    symbol: getCurrencySymbol(code),
  }))

export default Money
